const ERROR_WRONG_EMAIL = 'ERROR_WRONG_EMAIL';
const EMAIL_ALREADY_TAKEN = 'EMAIL_ALREADY_TAKEN';

export {
    ERROR_WRONG_EMAIL,
    EMAIL_ALREADY_TAKEN,
};
